module.exports = __webpack_public_path__ + "static/strava-e34cd0a88f4207b86d01e157829865e7.png";